import { Component, input } from '@angular/core';
import { MatSymbol } from '../../models/mat-symbol.interface';

@Component({
  selector: 'pozi-symbol',
  imports: [],
  templateUrl: './symbol.component.html',
  styleUrl: './symbol.component.scss',
})
export class SymbolComponent {
  matSymbol = input.required<MatSymbol>();

  readonly defaultStyle = 'rounded';
  readonly defaultSizeInPx = 20;
}
